module.exports = __webpack_public_path__ + "static/media/bm.f2a17828.svg";